import React from "react";
import { Link } from "react-router-dom";
import NewsSection from "./NewsSection";

const AboutUs = () => {
  return (
    <section id="about-us" className="pb-10 bg-gray-50">
      <div className="p-6 md:p-0 grid md:grid-cols-2 gap-10 bg-white">
        {/* Left Column — News */}
        <div>
          <NewsSection />
        </div>

        {/* Right Column — Mission / Vision / About */}
        <div className="container bg-white md:pr-16 md:pt-16">

          {/* Mission */}
          <div className="text-center mb-10">
            <h3 className="text-3xl font-semibold text-gray-700">
              Our Mission
            </h3>
            <p className="mt-4 text-gray-600 leading-relaxed">
              To promote quality education by enforcing compliance with approved curricula, strengthening school supervision, and delivering credible, transparent and technology-driven examinations that uphold the highest standards in Basic and Senior Secondary education.
            </p>
          </div>

          {/* Vision */}
          <div className="text-center mb-10">
            <h3 className="text-3xl font-semibold text-gray-700">
              Our Vision
            </h3>
            <p className="mt-4 text-gray-600 leading-relaxed">
              To be a trusted regulator that guarantees excellence, integrity and uniform standards in teaching, learning and examinations across all schools below tertiary level in Benue State.
            </p>
          </div>

          {/* About */}
          <div className="text-left space-y-4">
            <h3 className="text-3xl font-semibold text-gray-700 mb-4">
              About Us
            </h3>
            <p className="text-gray-600 leading-relaxed">
              The Benue State Education Quality Assurance and Examinations Board (BEQAEB) was established under the Benue State Education Quality Assurance and Examinations Board Law, 2025 to provide a unified, efficient and transparent framework for education quality assurance and the conduct of all state examinations. The Board is mandated to uphold uniform standards across Basic and Senior Secondary education, ensure compliance with approved curricula, and supervise the effective administration of the Basic Education Certificate Examination (BECE), MOCK SSCE and other examinations as may be assigned by the State Government.
            </p>
            
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
